import theme from '@styles/theme';
export default {
  productDescriptionItem: {
    height: 'auto',
    width: '100%',
    borderTop: `1px solid ${theme.rawColors.lightGrey700}`,
    ul: {
      paddingLeft: '16px'
    },
    a: {
      textDecoration: 'underline'
    },
    'ul > li': {
      listStyle: 'none',
      padding: '0 16px 16px',
      display: 'block',
      position: 'relative',
      '&:before': {
        content: '" "',
        position: 'absolute',
        top: '8px',
        left: '0px',
        border: `1px solid ${theme.rawColors.darkGrey700}`,
        borderRadius: '50%',
        width: '1px',
        height: '1px'
      }
    }
  },
  productDescriptionItems: (showDetails: boolean) => ({
    height: showDetails ? 'auto' : '0',
    overflow: showDetails ? 'unset' : 'hidden',
    transition: 'height 0.3s ease-in-out'
  }),
  headerContainer: {
    display: 'flex',
    margin: ['20px 0', '20px 0', '24px 0', '24px 0', '27px 0'],
    alignItems: 'space-between',
    h3: {
      fontSize: theme.fontSizes.h3
    },
    'h4::first-letter': {
      textTransform: 'uppercase'
    },
    ':hover': {
      cursor: 'pointer'
    }
  },
  addButton: {
    marginRight: ['11px', '11px', '11px', '11px', '13px'],
    '.button-children-wrapper': {
      justifyContent: 'space-between',
      width: '100%',
      textAlign: 'left'
    }
  },
  heading: {
    '&::first-letter': {
      textTransform: 'uppercase'
    }
  },
  productDescriptionItemContent: {
    margin: 'auto',
    ul: {
      padding: '0 16px 24px'
    }
  },
  productShowMoreContainer: {
    height: 'auto',
    width: '100%',
    position: 'absolute',
    zIndex: theme.zIndex.documentHigh,
    bottom: '0',
    left: '0',
    textAlign: 'center'
  },
  productShowMoreButton: {
    color: theme.rawColors.darkGrey700,
    cursor: 'pointer',
    position: 'absolute',
    bottom: '0',
    left: '0',
    width: '100%'
  }
};